import interrupt from "../interrupt";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-transition/src/selection/interrupt.js
// module id = ../../../../d3-transition/src/selection/interrupt.js
// module chunks = 3